export default __webpack_public_path__ + "static/media/keno-loose_3.26306fbf.mp3";